module.exports = __webpack_public_path__ + "img/modal-block2.e896703.png";